module.exports = __webpack_public_path__ + "static/media/check.4b09b6f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/utils/images/check.svg
// module id = 287
// module chunks = 1